export default function getRequestUserTokenClientId() {
    return window.env.API_ACCESS_CLIENT_ID || 'ADLqfy4M6cRUaEL6XOxiKpMqyPvjTuUi';
}
